import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import { keyByProperty } from '../../helpers/core';
import { updateSettings } from '../../helpers/utility';
import { logger } from '../../helpers/logger';
import appSettings from '../../settings/index';
import notifications from '../../redux/notifications/actions';
import { getCurrentLanguage, setLanguage, t } from '../../i18n';
import { LOCAL_SETTINGS_KEY } from '../../helpers/localStorageKeys.const';
import { getCurrentCountryContext } from '../../helpers/countriesHelpers';

function* loadSettings() {
  const settings = JSON.parse(localStorage.getItem(LOCAL_SETTINGS_KEY)) || {};

  if (!settings.language) {
    settings.language = getCurrentLanguage();
  }

  if (!settings.apiUrl) {
    settings.apiUrl = appSettings.apiUrl;
  }

  if (!settings.wsUrl) {
    settings.wsUrl = appSettings.wsUrl;
  }

  yield put(actions.initDataCompleted({ settings }));
}

function* save(data) {
  try {
    const { editForm } = data.payload;
    const propsArray = Object.values(editForm);
    const settings = keyByProperty(propsArray, 'name', prop => prop.value);

    yield updateSettings(settings);
    yield put(actions.saveSuccess({ settings }));
    yield put(
      notifications.addNotification({
        headline: t('dash.common.notification.success_headline'),
        type: 'success',
        message: 'Settings saved',
      }),
    );
  } catch (error) {
    logger.error(error);
  }
}

function* clearSettings() {
  try {
    const settings = JSON.parse(localStorage.getItem(LOCAL_SETTINGS_KEY)) || {};

    settings.apiUrl = appSettings.apiUrl;
    settings.wsUrl = appSettings.wsUrl;
    settings.language = getCurrentCountryContext().locale;

    setLanguage(settings.language);

    localStorage.setItem(LOCAL_SETTINGS_KEY, JSON.stringify(settings));
    yield put(actions.clearSettingsSuccess({ settings }));

    yield put(
      notifications.addNotification({
        headline: t('dash.common.notification.success_headline'),
        type: 'success',
        message: 'Settings updated to default',
      }),
    );

    yield window.location.reload();
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.INIT_DATA, loadSettings),
    takeEvery(actions.SAVE, save),
    takeEvery(actions.CLEAR_SETTINGS, clearSettings),
  ]);
}
